import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    issueStatus: {
      fontFamily: 'Archivo',
      fontStyle: 'normal',
      fontWeight: 700,
      letterSpacing: '0em',
      textTransform: 'capitalize',
      alignSelf: 'center',
      color: '#8A8A8A',
    },
    small: {
      fontSize: '0.875rem',
      lineHeight: '11px',
    },
    default: {},
    issueCard: {
      fontSize: '0.75rem',
    },
  })
);
